/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray, boolean as codecBoolean, number as codecNumber, string as codecString, } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AutoTestGlobalSetupOutput } from './AutoTestGlobalSetupOutput';
import { AutoTestQualityComment } from './AutoTestQualityComment';
import { AutoTestResult } from './AutoTestResult';
import { AutoTestRunner } from './AutoTestRunner';
import { AutoTestStepResult } from './AutoTestStepResult';
import { FileTree } from './FileTree';
const ExtendedAutoTestResultParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    [
        'globalSetupOutput',
        /* #__PURE__ */ codecArray(AutoTestGlobalSetupOutput),
        'global_setup_output',
    ],
    [
        'setupStdout',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'setup_stdout',
    ],
    [
        'setupStderr',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'setup_stderr',
    ],
    [
        'stepResults',
        /* #__PURE__ */ codecArray(AutoTestStepResult),
        'step_results',
    ],
    [
        'approxWaitingBefore',
        /* #__PURE__ */ parsers.maybeNull(codecNumber),
        'approx_waiting_before',
    ],
    ['finalResult', codecBoolean, 'final_result'],
    [
        'suiteFiles',
        /* #__PURE__ */ codec.record(codecString, /* #__PURE__ */ codecArray(FileTree)),
        'suite_files',
    ],
    [
        'qualityComments',
        /* #__PURE__ */ codecArray(AutoTestQualityComment),
        'quality_comments',
    ],
    [
        'possibleRunners',
        /* #__PURE__ */ parsers.maybeNull(/* #__PURE__ */ codecArray(AutoTestRunner)),
        'possible_runners',
    ],
])), AutoTestResult);
export class ExtendedAutoTestResult extends AutoTestResult {
    static decode(input) {
        return ExtendedAutoTestResultParser.decode(input).map(res => new ExtendedAutoTestResult(res));
    }
    static unsafeDecode(input) {
        return ExtendedAutoTestResult.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtendedAutoTestResultParser.encode(data);
    }
    static schema() {
        return ExtendedAutoTestResultParser.schema();
    }
}
